/* Das Fenster nach den vier Fragen.

   Ablauf: die Fragenseite leitet auf die Produktseite weiter und haengt
   fpIntro an. Dieses Skript zeigt sofort das Fenster mit dem Entwurf,
   waehrend dahinter der Konfigurator laedt. Wer sich entscheidet,
   loest ueber "In den Warenkorb" den eigenen Knopf des Konfigurators
   aus, wer weiter anpassen will, schliesst das Fenster.

   Der Knopf des Konfigurators statt eines eigenen Aufrufs an
   /cart/add: das Plugin schreibt an der Zeile im Warenkorb acht
   Eigenschaften plus _3D Customizer URL, und ueber die laesst sich die
   Konfiguration spaeter wieder oeffnen. Das nachzubauen hiesse, ein
   fremdes Format zu raten, und ein Fehler darin faellt niemandem auf,
   bis das Paar falsch in der Werkstatt liegt. */

(function () {
  'use strict';

  var ATC = '.tda-customizer-footer-atc-btn';
  var PREIS = '.tda-customizer-variant-price';
  var OPTION = '.tda-customizer-customization-option';

  /* Der Konfigurator hat zwei voellig verschiedene Oberflaechen. Am
     Schreibtisch stehen die Gruppen untereinander, auf dem Handy liegen
     sie als Folien in einem Karussell, und dort fehlt die Huelle
     .tda-customizer-customization-option ganz: gemessen 0 Gruppen, aber
     26 Werte und 8 davon markiert.

     Genau darauf hatte ich geprueft und daraus geschlossen, der
     Konfigurator sei auf dem Handy kaputt. Er ist es nicht. Die
     Einzelwerte tragen ihre Klasse in beiden Oberflaechen, also haengt
     die Pruefung jetzt daran. */
  var WERT = '.tda-customizer-customization-option-value';
  var GEWAEHLT = '.tda-customizer-customization-option-value-selected';
  var FRIST = 25000;

  var wurzel = document.querySelector('[data-fp-intro]');
  if (!wurzel) return;

  var entwurf = null;
  try {
    entwurf = new URLSearchParams(window.location.search).get('fpIntro');
  } catch (e) {
    entwurf = null;
  }
  if (!entwurf) return;

  var bilder = wurzel.querySelectorAll('[data-fp-intro-design]');
  var bild = wurzel.querySelector('[data-fp-intro-design="' + entwurf + '"]');
  if (!bild) return;

  var karte = wurzel.querySelector('.fp-intro__card');
  var knopf = wurzel.querySelector('[data-fp-intro-cart]');
  var knopfText = wurzel.querySelector('[data-fp-intro-cart-label]');
  var preisFeld = wurzel.querySelector('[data-fp-intro-price]');
  var wartetext = wurzel.getAttribute('data-wait') || '';
  var urtext = knopfText ? knopfText.textContent : '';

  var offen = false;
  var bereit = false;
  var gewollt = false;
  var vorher = null;
  var start = Date.now();

  function melde(name, daten) {
    if (window.fpClarity && typeof window.fpClarity.track === 'function') {
      window.fpClarity.track(name, daten || {});
    }
  }

  /* ----------------------------------------------------------------
     Oeffnen und schliessen
  ---------------------------------------------------------------- */
  function oeffne() {
    bild.hidden = false;
    wurzel.hidden = false;
    document.body.classList.add('fp-intro-open');
    offen = true;

    vorher = document.activeElement;
    if (karte) {
      karte.setAttribute('tabindex', '-1');
      karte.focus({ preventScroll: true });
    }

    /* fpIntro aus der Adresse nehmen. Sonst geht das Fenster beim
       Zurueckblaettern oder Neuladen wieder auf, obwohl die
       Entscheidung laengst gefallen ist. Der tdaState muss bleiben, an
       ihm haengt die Voreinstellung des Konfigurators. */
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('fpIntro');
      window.history.replaceState({}, '', u.toString());
    } catch (e) {
      /* Adresse unveraendert lassen, das Fenster steht trotzdem. */
    }

    melde('design_intro_shown', { design_intro_result: entwurf });
  }

  function schliesse(grund) {
    if (!offen) return;
    offen = false;
    wurzel.hidden = true;
    document.body.classList.remove('fp-intro-open');

    if (vorher && typeof vorher.focus === 'function') {
      vorher.focus({ preventScroll: true });
    }

    if (grund) {
      melde(grund, {
        design_intro_result: entwurf,
        design_intro_seconds: Math.round((Date.now() - start) / 1000),
      });
    }

    /* Hier stand ein Sprung zum Konfigurator. Er lief ins Leere, und
       zwar aus einem guten Grund: die Produktseite sperrt ihr eigenes
       Scrollen, der Konfigurator bringt sein Scrollen selbst mit und
       fuellt nach dem Schliessen ohnehin das ganze Fenster. Ein Aufruf,
       der nie etwas bewirkt, gehoert nicht in den Code. */
  }

  wurzel.addEventListener('click', function (e) {
    var zu = e.target.closest('[data-fp-intro-close]');
    if (!zu) return;

    /* Zwei verschiedene Absichten hinter demselben Schliessen: "Weiter
       anpassen" ist eine Entscheidung fuer den Konfigurator, das Kreuz
       und die Flaeche daneben sind ein Wegklicken. Im Trichter sind das
       zwei sehr verschiedene Ausgaenge. */
    var weiter = zu.classList.contains('fp-intro__more');
    schliesse(weiter ? 'design_intro_customize' : 'design_intro_dismissed');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && offen) schliesse('design_intro_dismissed');
  });

  /* ----------------------------------------------------------------
     Auf den Konfigurator warten
  ---------------------------------------------------------------- */
  function pruefeBereit() {
    var b = document.querySelector(ATC);
    if (!b) return false;
    return !!(b.offsetWidth || b.offsetHeight);
  }

  /* Der Konfigurator meldet sich bereit, sobald Knopf und Optionen
     stehen. Sein Preisfeld kommt kurz danach, gemessen bis zu zwei
     Sekunden spaeter. Ein einziger Versuch traf deshalb ins Leere und
     das Fenster blieb ohne Preis.

     Bleibt der Preis ganz aus, zeigt das Fenster eben keinen. Das ist
     besser als eine Zahl aus der Produktseite, die die Aufpreise der
     Voreinstellung nicht kennt. */
  var preisVersuche = 0;

  function preisSpiegeln() {
    if (!preisFeld) return;

    var p = document.querySelector(PREIS);
    var t = p ? p.textContent.replace(/\s+/g, ' ').trim() : '';

    if (t) {
      preisFeld.textContent = t;
      preisFeld.hidden = false;
      return;
    }

    preisVersuche += 1;
    if (preisVersuche <= 20) window.setTimeout(preisSpiegeln, 400);
  }

  /* Der Konfigurator merkt sich den letzten Stand einer Sitzung. Wer
     den Fragebogen ein zweites Mal durchlaeuft, bekommt deshalb unter
     Umstaenden eine andere Farbe eingestellt, als der Fragebogen eben
     ermittelt hat. Beim Nachmessen im Warenkorb ist genau das passiert:
     das Fenster zeigte Executive Mitternacht, im Warenkorb landete
     Cognac.

     Das Bild richtet sich deshalb nach dem, was der Konfigurator
     wirklich haelt, und nicht nach dem, was der Fragebogen erwartet
     hat. Jede der drei Farben hat genau ein Foto, die Zuordnung ist
     damit immer moeglich. Lieber ein Foto, das nicht zur Empfehlung
     passt, als eines, das nicht zum Schuh passt. */
  function bildZuFarbe(wert) {
    if (!wert) return null;
    var w = wert.replace(/\s+/g, ' ').trim().toLowerCase();
    if (!w) return null;

    for (var j = 0; j < bilder.length; j++) {
      var liste = (bilder[j].getAttribute('data-fp-intro-colour') || '').toLowerCase().split('~');
      if (liste.indexOf(w) > -1) return bilder[j];
    }
    return null;
  }

  function farbBild() {
    /* Am Schreibtisch traegt der markierte Wert seinen Namen als Text.
       Auf dem Handy sind die Farbwerte reine Bildflaechen ohne
       Beschriftung, dort traegt hoechstens ein Titel den Namen. */
    var markiert = document.querySelectorAll(GEWAEHLT);

    for (var i = 0; i < markiert.length; i++) {
      var e = markiert[i];
      var treffer = bildZuFarbe(e.textContent) ||
        bildZuFarbe(e.getAttribute('title')) ||
        bildZuFarbe(e.getAttribute('aria-label'));
      if (treffer) return treffer;
    }
    return null;
  }

  function bildAngleichen() {
    var treffer = farbBild();
    if (!treffer || treffer === bild) return;

    melde('design_intro_colour_mismatch', {
      design_intro_result: entwurf,
      design_intro_shown: treffer.getAttribute('data-fp-intro-design'),
    });

    bild.hidden = true;
    treffer.hidden = false;
    bild = treffer;
  }

  function anpassenPruefen() {
    if (document.querySelector(WERT)) return;

    var mehr = wurzel.querySelector('.fp-intro__more');
    if (mehr) mehr.hidden = true;

    melde('design_intro_no_options', {
      design_intro_result: entwurf,
      design_intro_breite: window.innerWidth,
    });
  }

  function jetztBereit() {
    if (bereit) return;
    bereit = true;
    bildAngleichen();
    anpassenPruefen();
    preisSpiegeln();

    melde('design_intro_ready', {
      design_intro_result: entwurf,
      design_intro_wait_ms: Date.now() - start,
    });

    /* Wer waehrend des Ladens geklickt hat, hat sich entschieden. Der
       Wunsch wird jetzt nachgeholt, statt ihn noch einmal zu verlangen. */
    if (gewollt) legeAn();
  }

  var beobachter = new MutationObserver(function () {
    if (pruefeBereit()) {
      beobachter.disconnect();
      jetztBereit();
    }
  });

  /* ----------------------------------------------------------------
     In den Warenkorb
  ---------------------------------------------------------------- */
  function legeAn() {
    var b = document.querySelector(ATC);
    if (!b) {
      /* Nicht behaupten, es haette geklappt. Fenster zu, der
         Konfigurator steht dahinter und kann bedient werden. */
      melde('design_intro_add_failed', { design_intro_result: entwurf });
      schliesse(null);
      return;
    }

    melde('design_intro_add_to_cart', {
      design_intro_result: entwurf,
      design_intro_seconds: Math.round((Date.now() - start) / 1000),
    });

    schliesse(null);
    b.click();
  }

  if (knopf) {
    knopf.addEventListener('click', function () {
      if (bereit) {
        legeAn();
        return;
      }

      /* Noch nicht bereit: den Wunsch merken und sagen, dass etwas
         passiert. Ein Knopf, der nichts tut, liest sich als Fehler. */
      gewollt = true;
      knopf.setAttribute('data-busy', '');
      if (knopfText && wartetext) knopfText.textContent = wartetext;

      melde('design_intro_add_queued', {
        design_intro_result: entwurf,
        design_intro_wait_ms: Date.now() - start,
      });
    });
  }

  /* ----------------------------------------------------------------
     Start
  ---------------------------------------------------------------- */
  oeffne();

  if (pruefeBereit()) {
    jetztBereit();
  } else {
    beobachter.observe(document.body, { childList: true, subtree: true });

    window.setTimeout(function () {
      if (bereit) return;
      beobachter.disconnect();

      melde('design_intro_timeout', { design_intro_result: entwurf });

      /* Nach der Frist nicht weiter warten lassen. Wer den Knopf
         gedrueckt hat, bekommt das Fenster aus dem Weg und sieht, was
         die Seite tatsaechlich anbietet. */
      if (gewollt) {
        if (knopf) {
          knopf.removeAttribute('data-busy');
          if (knopfText) knopfText.textContent = urtext;
        }
        schliesse(null);
      }
    }, FRIST);
  }
})();
